module.exports = __webpack_public_path__ + "img/doorLogo33.25d3cda9.png";